export const getButtonLoadingStyles = isLoading => ({
  // fade in content after done loading data
  transition: "opacity 0.3s",
  opacity: isLoading ? 0 : 1
});
//# sourceMappingURL=getButtonLoadingStyles.js.map